export class CenterCurrency {

    private codeIso4217: string;
    private description: string;
    private internalId: string;
    private numberIso4217: string;

    constructor(internalId?: string, codeIso4217?: string, description?: string, numberIso4217?: string) {
        this.codeIso4217 = codeIso4217;
        this.description = description;
        this.internalId = internalId;
        this.numberIso4217 = numberIso4217;
    }

    public get CodeIso4217() {
        return this.codeIso4217;
    }
    public get Description() {
        return this.description;
    }
    public get InternalId() {
        return this.internalId;
    }
    public get NumberIso4217() {
        return this.numberIso4217;
    }

    public set CodeIso4217(codeIso4217) {
        this.codeIso4217 = codeIso4217;
    }
    public set Description(description) {
        this.description = description;
    }
    public set InternalId(internalId) {
        this.internalId = internalId;
    }
    public set NumberIso4217(numberIso4217) {
        this.numberIso4217 = numberIso4217;
    }

}
